// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","time":"time-3AMbz","airport":"airport-1R4Jq","point_thin":"point_thin-hfKRS"};